export default Object.freeze({
  Codes: [
    1001, // HEADER_NOT_FOUND
    1002, // IS_BEING_USED
    1003, // INVALID_TOKEN
  ],
  HeaderNotFoundCode: 1001,
  IsBeingUsedCode: 1002,
  InvalidTokenCode: 1003,
});
